import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, OnInit, ViewChild } from '@angular/core';

import { IonButton, IonCol, IonGrid, IonModal, IonRow } from '@ionic/angular/standalone';

import { register } from 'swiper/element/bundle';

import { CloseButtonComponent } from '../buttons/close-button/close-button.component';

register();

@Component({
    selector: 'lib-gallery-lightbox',
    standalone: true,
    imports: [IonButton, IonModal, CommonModule, CloseButtonComponent, IonCol, IonGrid, IonRow],
    templateUrl: './gallery-lightbox.component.html',
    styleUrl: './gallery-lightbox.component.css',
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class GalleryLightboxComponent implements OnInit {
    /* eslint-disable */
    @Input() images: { image_url: string; description: string | null }[] = [];
    @Input() imagesAsString: string[] = [];
    @Input() initialSelectedImage: any = null;
    @Input() thumbnailDisplay: 'slider' | 'grid' = 'grid';
    @Input() slidesPerView: number = 3.5;
    @Input() slidePagination: boolean = false;
    @Input() slideSpaceBetween: number = 5;
    @Input() gridColumnWidth: number = 6;

    @Input() additionalClasses: string = '';

    @ViewChild('modal') modal!: IonModal;

    selectedImage: any = null;

    lightboxImage: any = null;

    ngOnInit(): void {
        setTimeout(() => {
            if (this.initialSelectedImage) {
                this.displayLightbox({
                    image_url: this.initialSelectedImage.image_url,
                    description: this.initialSelectedImage.description || null
                });
            }
        }, 0);
    }

    displayLightbox(img: { image_url: string; description: string | null } | string) {
        this.lightboxImage = img;
        this.modal.present();
    }

    dismissLightbox() {
        this.modal.dismiss();

        this.lightboxImage = null;
    }
}
